import React, {Component} from 'react';
import { Button, Form, Message } from 'semantic-ui-react'
import {client} from '../../Client';
import LocalDate from '../LocalDate'
import Moment from 'moment'
import {Redirect} from 'react-router-dom';
import PropTypes from 'prop-types';
import 'react-date-picker/index.css'
import ErrorMessage from '../ErrorMessage'

class AttivitaNuova extends Component {
    constructor(props) {
        super(props);
        this.state = {
            fields: this.getEmptyFields(),
            fieldErrors: {},
            fieldErrorsText: [],
            inError: false,
            _loading: false,
            errorTitle: '',
            saveSuccess: false,
            error: null,
        };
        this.getEmptyFields = this.getEmptyFields.bind(this)
        this.onChange = this.onChange.bind(this)
        this.onInputChange = this.onInputChange.bind(this)
        this.handleSubmit = this.handleSubmit.bind(this)
        this.formIsValid = this.formIsValid.bind(this)
        this.isLoadingInProgress = this.isLoadingInProgress.bind(this)
        this.getInizio = this.getInizio.bind(this)
        this.onOraAttualeClick = this.onOraAttualeClick.bind(this)
        this.onOraEventoPrecClick = this.onOraEventoPrecClick.bind(this)
    }

    componentWillReceiveProps(nextProps, nextContext){
        let inizio = this.getInizio(nextProps, nextContext);
        let fields = Object.assign({}, this.state.fields);
        fields["inizio"] = inizio;
        this.setState({fields});
    }

    onOraAttualeClick(ev) {
        ev.preventDefault();
        let fields = Object.assign({}, this.state.fields);
        fields["inizio"] = Moment().format("HH:mm");
        this.setState({fields})
    }

    onOraEventoPrecClick(ev) {
        let fields = Object.assign({}, this.state.fields);
        fields["inizio"] = this.getInizioEventoPrec(this.props)
        this.setState({fields})
    }

    /**
     * Restituisce l'ora di fine dell'evento precedente.
     * Se non c'è un evento precedente, restituisce l'ora attuale.
     *
     * @returns {string}
     */
    getInizioEventoPrec(props){
        let inizio = Moment().format("HH:mm");
        if (props !== undefined && props.itemPrev !== undefined && props.itemPrev.fine !== null) {
            inizio = Moment(props.itemPrev.fine).format("HH:mm");
        }
        return inizio;
    }

    getInizio(props){
        let inizio = Moment().format("HH:mm");
        if (this.props.inizio){
            inizio = this.props.inizio;
        }
        // Se non ci sono altre attività, l'ora di inizio proposta è quella corrente e non più
        // presa dalla configurazione
        // else  {
        //     inizio = client.getConfigurazione().oraInizioStandard;
        // }

        return inizio;
    }

    onChange() {
        if (this.props.onChange)
        {
            this.props.onChange();
        }
    }

    getEmptyFields() {

        return {
            'inizio' : this.getInizio(this.props),
        }
    }

    formIsValid(formData) {
        // Validazione dati
        let fieldErrorsText = []
        let fieldErrors = {}

        if (this.state.fields.inizio === undefined )
        {
            fieldErrors["inizio"] = true;
            fieldErrorsText.push("Occorre specificare l'ora di inizio di questa nuova attività");
        }

        if (Object.keys(fieldErrors).length > 0)
        {
            this.setState({
                fieldErrors: fieldErrors,
                fieldErrorsText: fieldErrorsText,
                errorTitle:"La form contiene errori",
                inError: true
            })
            return false;
        }
        return true;
    }

    onInputChange(a1, {name, value}){
        if (name !== undefined)
        {
            const fields = this.state.fields;
            let prevValue = fields[name];
            fields[name] = value;
            if (name === 'inizio'){

                if (value.length === 2 && !value.includes(':')){
                    if (prevValue.length === 3 && prevValue.includes(':')){
                        fields[name] = '';
                    }
                    else
                    {
                        fields[name] += ':';
                    }
                }
            }
            this.setState({ fields, fieldErrors: {}, fieldErrorsText:[], errorTitle:'', inError: false });
        }
    }

    handleSubmit(e) {
        e.preventDefault();
        let formData = this.state.fields;

        // Validazione form
        if (!this.formIsValid(this.state.fields)){
            return;
        }

        let fields = {
            idCommessa: this.props.commessa.idCommessa,
            giorno: this.props.giorno,
            inizio: this.props.giorno + ' ' + formData["inizio"],
            idUtente: client.getCurrentUserId(),
        };
        if (this.props.nota){
            fields = {...fields, 'nota': this.props.nota};
        }

        this.setState({_loading: true});
        client.saveAttivita(
            fields
        ).then((response) => {
            if (response.ok){
                response.json().then((data) => {
                    this.setState({
                        _loading: false,
                        inError: false,
                        fieldErrors: {},
                        fieldErrorsText: [],
                        saveSuccess: true,
                        attivitaSaved: data,
                    });
                })
            }
            else if (response.status === 401)
            {
                this.props.history.push("/login")
            }            else
            {
                response.json().then((error) => {
                    let fieldErrorsText = []
                    let fieldErrors = {}

                    if (error.errors !== undefined){
                        Object.keys(error.errors).map((item) => {
                            fieldErrors[item] = true;
                            fieldErrorsText = fieldErrorsText.concat(item + ":" +error.errors[item]);
                            return 0;
                        });
                    }
                    else {
                        fieldErrorsText = [error.message]
                    }
                    this.setState({
                        _loading: false,
                        fieldErrors: fieldErrors,
                        fieldErrorsText: fieldErrorsText,
                        errorTitle:error.title,
                        inError: true
                    });
                })
            }
        }).catch((error) => {
            this.setState({
                _loading: false,
                fieldErrors: {},
                fieldErrorsText: [error.message],
                errorTitle: "Errore di rete imprevisto",
                inError: true
            });
        });
    }

    isLoadingInProgress(){
        return this.state._loading;
    }


    render() {
        if (this.props.commessa === undefined){
            return <div>Per poter registrare una nuova attività, <b>Selezionare prima una commessa!</b></div>
        }
        if (this.state.error !== null)
        {
            return (<ErrorMessage title={this.state.error.title} msg={this.state.error.msg} />)
        }

        let formInError = this.state.fieldErrorsText.length > 0;

        if (this.state.saveSuccess || this.state.cancelSuccess){
            return <Redirect to={ {
                pathname: '/app/attivita',
                state: {
                    from: this.props.location,
                    item: this.state.attivitaSaved,
                },
            }}/>
        }

        //
        // Se il giorno di lavoro è diverso da quello attuale si visualizzano i pulsanti lampeggianti
        //
        let btnStyle = null;
        let ora = Moment().format("YYYY-MM-DD");
        if (ora !== this.props.giorno){
            btnStyle = "fading-in-out-button" ;
        }
        let notePreimpostate = null;
        if (this.props.nota){
            notePreimpostate = (<em>Note: {this.props.nota}</em>);
        }

        return <div>

            <Form onSubmit={this.handleSubmit} error={formInError} loading={this.state._loading} success={this.state.saveSuccess}>
                <Form.Group inline>
                    <Form.Field>
                        <h3><label className="ui empty circular label" style={{backgroundColor: this.props.commessa.colore, marginRight: "5px"}}></label>{this.props.commessa.codice} {this.props.commessa.nome} - Avvio <b><LocalDate data={this.props.giorno} inline /></b> ore</h3>
                    </Form.Field>
                    <Form.Input name='inizio' style={{width: "80px"}}  pattern="^[0-9]{1,2}:[0-9]{1,2}$" autoComplete="nope" required={true}  value={this.state.fields.inizio} error={this.state.fieldErrors["inizio"]} onChange={this.onInputChange}/>
                    <Button loading={this.isLoadingInProgress()} onClick={this.onOraAttualeClick}><i className="clock icon"/> Ora attuale</Button>
                    <label className="label"/>
                    <Button className={btnStyle} primary type='submit' loading={this.isLoadingInProgress()}><i className="play icon"/> Avvia</Button>
                    <Button className={btnStyle} primary type='submit' loading={this.isLoadingInProgress()} onClick={this.onOraEventoPrecClick}><i className="clock icon"/> Retro Avvio</Button>
                </Form.Group>
                {notePreimpostate}
                <Message
                    error
                    header={this.state.errorTitle}
                    list={this.state.fieldErrorsText}
                />
                <Message
                    success
                    header={this.state.successTitle}
                    content={this.state.successText}
                    icon={"smile"}
                />
            </Form>

        </div>
    }
}

AttivitaNuova.PropTypes = {
    item: PropTypes.object.isRequired,
    itemPrev: PropTypes.object.isRequired,
    commessa: PropTypes.object.isRequired,
    giorno: PropTypes.string.isRequired,
    nota: PropTypes.string.isRequired,
    inizio: PropTypes.string.isRequired,
}

export default AttivitaNuova;




/** WEBPACK FOOTER **
 ** ./src/components/attivita/AttivitaNuova.jsx
 **/